module.exports = __webpack_public_path__ + "static/media/person-blue.1dc074a4.svg";